import React from "react";
import AccordionCard from "../../../../../components/common/PL/AccordionCard/AccordionCard";
import BundleKey from "../../../../../translation/bundleKey";
import Toast from "../../../../../components/common/PL/Toast/Toast";
import AutorizacionesList from "../AccessTypeForm/TransportContentForm/AutorizacionesList";
import AutorizacionesEgresoList from "../AccessTypeForm/TransportContentForm/AutorizacionesEgresoList";
import RegistrarAutorizacionModal from "../AccessTypeForm/TransportContentForm/RegistrarAutorizacionModal";
import { TransportAuthorizationFlow } from "../AccessTypeForm/TransportContentForm/useTransportAuthorizationFlow";
import "./AutorizacionesForm.css";

type AutorizacionesFormProps = {
  formId: string;
  disabled?: boolean;
  flow: TransportAuthorizationFlow;
};

const AutorizacionesForm = ({ formId, disabled = false, flow }: AutorizacionesFormProps) => {
  return (
    <AccordionCard
      id={`${formId}-authorizations`}
      titleKey={BundleKey.DETAIL_AUTHORIZATION_TITLE}
      number={5}
      expanded
    >
      {/* Único anchor de "Autorización de transporte" en el DOM: tiene que existir desde antes de
          elegir una empresa (todavía no hay pedido/autorización elegida), así que no se puede
          montar sólo cuando `selectedEmpresa` está definido — si no, "Ver faltante" no encuentra
          nada para el caso más común, el campo vacío de punta a punta, en ningún flujo. */}
      <div className="autorizacionesFormContent" data-field-name="transportAuthorizationSelected">
        {flow.selectedEmpresa ? (
          flow.flujo === "entrada" ? (
            <AutorizacionesList
              groups={flow.entryGroups}
              isLoading={flow.isLoading}
              expandedGroupId={flow.expandedGroupId}
              onToggleExpandGroup={flow.handleToggleExpandGroup}
              selectedRowId={flow.selectedRowId}
              onSelectRow={flow.handleSelectRow}
              onResendRow={flow.handleResend}
              onRegistrarPorOtroMedio={flow.setRegistrarAuthId}
              onRequestAuthorization={flow.handleRequestEntryAuthorization}
              onRefresh={flow.onRefresh}
              disabled={disabled}
              prefillVehiclePlate={flow.vehiclePlate}
              prefillRemito={flow.transportNumeroRemito}
              isSolicitarModalOpen={flow.isSolicitarModalOpen}
              onOpenSolicitarModal={flow.handleOpenSolicitarModal}
              onCloseSolicitarModal={flow.handleCloseSolicitarModal}
              solicitarModalPrefillCompany={flow.solicitarModalPrefillCompany}
            />
          ) : (
            <AutorizacionesEgresoList
              groups={flow.exitGroups}
              isLoading={flow.isLoading}
              selectedAutorizacionId={flow.selectedAutorizacionEgresoId}
              onSelectAutorizacion={flow.handleSelectAutorizacionEgreso}
              onResend={flow.handleResend}
              onRegistrarPorOtroMedio={flow.setRegistrarAuthId}
              onRequestAuthorization={flow.handleRequestExitAuthorization}
              prefillCompanyId={flow.entranceAuthorizingCompanyId}
              prefillVehicles={flow.authorizationVehiclePrefill}
              prefillRemito={flow.transportNumeroRemito}
              onRefresh={flow.onRefresh}
              onControlsChange={flow.handleExitControlsChange}
              disabled={disabled}
            />
          )
        ) : (
          <p className="autorizacionesFormEmptyState">
            Seleccioná una empresa transportista en "Tipo de autorización" para ver o solicitar
            autorizaciones.
          </p>
        )}
      </div>

      <RegistrarAutorizacionModal
        open={!!flow.registrarAuthId}
        onClose={() => flow.setRegistrarAuthId(null)}
        variant={flow.flujo}
        previousObservations={flow.registrarAuthObservations}
        onSubmit={flow.handleRegistrarAutorizacion}
      />

      <Toast
        open={flow.toast.open}
        message={flow.toast.message}
        severity={flow.toast.severity}
        onClose={() => flow.setToast((prev) => ({ ...prev, open: false }))}
      />
    </AccordionCard>
  );
};

export default AutorizacionesForm;
